/** @jsx jsx */
import {jsx, Flex, Styled, Heading} from 'theme-ui'
import * as React from "react"
import YAMLData from "../../content/metadata/My-YAML-Content.yaml"
import { graphql, useStaticQuery } from "gatsby"
import { Link } from "gatsby"
import {useState} from "react"
import Layout from '../components/layout'
import SEO from '../components/SEO'
import {useEffect} from "react"
import { TiArrowDownThick as Arw } from 'react-icons/ti';
import { IconContext } from "react-icons";

const MAX_POSTS = 5; 

const PostLink = ({ post }) => (
  <div>
  <Flex sx={{py: [3,4], borderTop: '1px solid', borderColor: 'shdtxt'}}>
    <span sx={{flex: '1 1 0%' }}>
     
    <Link to={post.fields.slug} sx={theme => ({...theme.styles.a}) }>
    {post.frontmatter.title} 
    </Link>
    </span>
    <time dateTime={post.frontmatter.isoDate}>{post.frontmatter.date}</time>

  </Flex>
  </div>
)



export default  () => {
  
  const data = useStaticQuery(graphql`
  {
    allMdx (
      sort: {
        fields: [frontmatter___date]
        order: DESC
      }
    ) {
      edges {
        node {
          id
          fields { 
            slug
          }
          
          frontmatter {
            title
              date(formatString: "MMM DD, YYYY")
              isoDate: date(formatString: "YYYY-MM-DD")
          }
        }
      }
    }
  }
`)

  const allBlogs = data.allMdx.edges;
  const [blogSubset, setBlogSubset] = useState([...allBlogs.slice(0, MAX_POSTS)])
  const [loadMore, setLoadMore] = useState(false)
  const [hasMore, setHasMore] = useState(allBlogs.length > MAX_POSTS)

  const handleLoadMore = () => setLoadMore(true)

  useEffect(() => {
    if (loadMore && hasMore) {
      const curLen = blogSubset.length
      const isMore = curLen < allBlogs.length
      console.log(isMore)
      const nxtBlogs = isMore ? allBlogs.slice(curLen, curLen + MAX_POSTS) : []
      setBlogSubset([...blogSubset, ...nxtBlogs])
      setLoadMore(false)
    }
  }, [loadMore, hasMore])

  useEffect(() => {
    const isMore = blogSubset.length < allBlogs.length
    setHasMore(isMore)
  }, [blogSubset])

  const Posts = blogSubset
    .map(edge => <PostLink key={edge.node.id} post={edge.node} />)

  return (
  <Layout>
  <SEO 
      description={`Ahmad's blog`} title={`Home`} />
      {/* <Heading sx={{backgroundColor: 'tx', color: 'background', padding:3, borderRadius:2}}>Posts</Heading> */}
     <div>
     {Posts}
     </div>
     {hasMore && <button onClick={handleLoadMore} 
     sx={{maxWidth: 'max-content', mx: 'auto', my:2, 
     display:'inline-block', color: 'text',cursor:'pointer' ,
      padding:3, backgroundColor:'transparent', border: '0' }}>
      More
        <IconContext.Provider value={{
      style: { verticalAlign:'middle', margin:'0 5px'},
        }}>
        
          <Arw {...{title: 'load more blogs'}} />
      </IconContext.Provider>
     </button>}
  </Layout>
  )
}



// const YAMLbuildtime = () => {
//   const [lang, setLang] = useState('en')

//   return (
//   <div style={{ maxWidth: `960px`, margin: `1.45rem` }}>
//     <h1>{YAMLData.title[lang]}</h1>
//     <button onClick={() => setLang(lang === 'ar' ? 'en': 'ar')}>Change lang</button>
//     <ul>
//       {YAMLData.content.map((data, index) => {
//         return <li key={`content_item_${index}`}>{data.item}</li>
//       })}
//     </ul>
//   </div>
// )
//     }

// export default YAMLbuildtime
// export const pageQuery = graphql`
// query {
//   allMdx(
//     sort: {
//       fields: [frontmatter___date]
//       order: DESC
//     }
//   ) {
//     edges {
//       node {
//         id
//         fields { 
//           slug
//         }
        
//         frontmatter {
//           title
//             date(formatString: "MMM DD, YYYY")
//             isoDate: date(formatString: "YYYY-MM-DD")
//         }
//       }
//     }
//   }
// }
// `
